// extracted by mini-css-extract-plugin
module.exports = {"suggests":"_6444e049b8--suggests--ngVqD","suggest":"_6444e049b8--suggest--zQKxX"};